import React, { useState, useEffect, useContext } from "react";
import { AuthService } from "../../api/AuthService";
import { ObjectLiteral } from "../../interfacesProps/ObjectLiteralProps";
import { RBCardView } from "../../components/RBCardView";
import { Spacing, Colors, FontSize } from "../../theme/Theme";
import {
  Typography,
  FormControl,
  Radio,
  RadioProps,
  withStyles,
  CircularProgress,
  InputBase,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { Claims, DefaultIndustryModeEnum, EmptyString } from "../../util/Common";
import { RBButton } from "../../components/RBButton";
import { ColumnStyle } from "../../theme/ComponentTheme";
import { useLocation, useHistory } from "react-router";
import { RoutePathConstant } from "../../util/Common";
import NotificationService, {
  NotificationServiceTopic,
} from "../../api/NotificationService";
import { RBContext } from "../../components/RBContext";
import { IndustryModeEnum } from "../../api/constants";
import { AlertInfoProps } from "../../interfacesProps/AlertInfoProps";
import { RBAlert } from "../../components/RBAlert";
import { AccountInfoContext } from "../../components/AccountInfoContext";

interface UpdatePharmacyProps {
  onClose: () => void;
}

export const UpdatePharmacy: React.FC<UpdatePharmacyProps> = ({ onClose }) => {
  const [availableTypes, setAvailableTypes] = useState<any[]>([]);
  const [selectedPharmacyId, setSelectedPharmacyId] = useState(EmptyString);
  const [accountInfo, setAccountInfo] = useState<ObjectLiteral>();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isAlertShowing, setIsAlertShowing] = useState(false);
  const [alertInfo, setAlertInfo] = useState<any>({ title: "", message: "", buttons: [] });
  const [searchTerm, setSearchTerm] = useState(EmptyString);
  const history = useHistory();
  const location = useLocation();
  const { industryMode, primaryColor, secondaryColor, updateMode } = useContext(RBContext);
  const { setAccountInformation } = useContext(AccountInfoContext);
  const [isLoading, setIsLoading] = useState(true);
  const [workerAndLocations, setWorkerAndLocations] = useState<any>(null);
  const { accountInformation, fetchAccountInfo } = useContext(AccountInfoContext);

  const onAccountChanged = (data: string) => {
    console.log("onAccountChanged", data);
    setRefresh((pre) => !pre);
  };

  useEffect(() => {
    const unsub = NotificationService.subscribe(
      NotificationServiceTopic.AccountChanged,
      onAccountChanged
    );
    const fetchData = async () => {

      if (!accountInformation) {
        console.log("accountInformation is null, cannot fetch data");
        return;
      }

      try {
        setIsLoading(true);
        const userData = accountInformation; // Use the accountInformation from context instead of fetching it again
        setAccountInfo(userData);
        console.log('userData switch location ', userData)
       const pharmacyId = userData.owner.defaultPharmacyId || userData.pharmacies[0].id;
             setSelectedPharmacyId(pharmacyId);
             console.log('selectedPharmacyId', pharmacyId);
       
             const [locationInfo, workerAndLocations] = await Promise.all([
               AuthService.getLocation(pharmacyId),
               AuthService.getRegisterEntities(),
             ]);
       
             const pharmacyLocation = locationInfo.data.companyType;
             const filteredData = workerAndLocations.data.filter(
               (value: any) => pharmacyLocation === value.locationType
             );
       
             updateMode(filteredData[0]?.industryMode);
             setWorkerAndLocations(workerAndLocations);
             
             const allNetwork = await AuthService.getAllNetworks(userData.networks[0].industryType);
             setAvailableTypes(allNetwork.data);
             if( userData.networks[0].industryModeDefault !== DefaultIndustryModeEnum.Custom){
                setAvailableTypes(allNetwork.data.filter((item:any) => item.industryMode === userData.networks[0].industryModeDefault));
             }
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
    };

    fetchData();
    return () => {
      console.log("UpdatePharmacy clean up");
      unsub.unsubscribe();
    };
  }, [refresh, accountInformation]);

  const handlePharmacyClick = async (pharmacyId: string) => {
    try {
      setIsSubmitting(true);
      setSelectedPharmacyId(pharmacyId);
      await AuthService.updateOwner({
        defaultPharmacyId: pharmacyId,
      });
      const locationInfo = await AuthService.getLocation(pharmacyId);
      localStorage.setItem("pharmacyName", locationInfo.data.name)

      // Perform a Refetch  
      const userData = await fetchAccountInfo();;
      setAccountInformation(userData);

      console.log('accountInfo switch ', userData);
      let pharmacyLocation = locationInfo.data.companyType;
      let filteredData = workerAndLocations.data.filter((value:any) => pharmacyLocation === value.locationType);
      updateMode(filteredData[0].industryMode);
      history.push(RoutePathConstant.DashBoard)
    } catch (error) {
      console.log("switch pharmacy save error ", error);
    } finally {
      setIsSubmitting(false);
      onClose(); // Close the modal once the saving process is completed
    }
  };

  const renderPharmacies = () => {
    let title = industryMode === IndustryModeEnum.Pharmaceutical ? 'pharmacy' :  industryMode === IndustryModeEnum.Dentistry ? 'dental practice' : 'company';
    let newTitle = industryMode === IndustryModeEnum.Pharmaceutical ? '*Pharmacy' :  industryMode === IndustryModeEnum.Dentistry ? '*Dental Practice' : '*Company';
    const filteredPharmacies =
      accountInfo?.pharmacies?.filter((pharmacy: any) =>
        pharmacy.name?.toLowerCase().includes(searchTerm.trim().toLowerCase())
      ) || [];
    return (
      <RBCardView
        style={{
          margin: 0,
          padding: Spacing.small,
          height: "100%",
          position: "relative",
          backgroundColor: "#f8f9fa",
        }}
      >
        <Typography
          variant={"subtitle2"}
          style={{ textAlign: "left", marginBottom: Spacing.small, padding: Spacing.small }}
        >
          Select a {title} to edit its information or post a shift
        </Typography> 
        <div
          style={{
            display: "flex",
            alignItems: "center",
            border: `1px solid ${Colors.mediumGrey}`,
            borderRadius: 999,
            background: Colors.white,
            padding: "6px 12px",
            margin: `0 ${Spacing.medium}px ${Spacing.small}px ${Spacing.medium}px`,
          }}
        >
          <SearchIcon
            style={{
              color: primaryColor,
              fontSize: 18,
              marginRight: 8,
            }}
          />
          <InputBase
            fullWidth
            placeholder={`Search ${title} name`}
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            style={{ fontSize: 13 }}
          />
        </div>
        <FormControl
          component="fieldset"
          style={{ backgroundColor: "#f8f9fa", display: "flex", flex: 1, padding: Spacing.medium, maxHeight: 300, overflowY: "auto" }}
        >
          {isLoading ? (
             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
             <CircularProgress 
               style={{ 
                 color: secondaryColor,
                 opacity: 0.8,
                 width: 40,
                 height: 40,
               }} 
               thickness={3}
             />
           </div>
          ):(
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'center' }}>
            {filteredPharmacies.map((pharmacy: any) => (
                <div
                  key={pharmacy.id}
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    width: '100%',
                    boxSizing: 'border-box',
                    position: 'relative',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    boxShadow: selectedPharmacyId === pharmacy.id 
                      ? `0 2px 8px rgba(0, 0, 0, 0.08)`
                      : '0 2px 8px rgba(0, 0, 0, 0.08)',
                    border: selectedPharmacyId === pharmacy.id ? `2px solid ${primaryColor}` : 'none',
                    backgroundColor: 'white',
                    color: 'black',
                    cursor: 'pointer',
                    transition: 'all 0.15s ease',
                    transform: 'translateY(0)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-0.5px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                  }}
                  onClick={() => handlePharmacyClick(pharmacy.id)}
                >
                    <div
                    style={{
                      width: 36,
                      height: 36,
                      borderRadius: "50%",
                      border: 'none',
                      marginRight: '12px',
                      backgroundColor: secondaryColor,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                    }}
                    >
                    <Typography variant="h6" style={{ 
                      color: "white",
                      fontSize: '16px',
                      fontWeight: 500,
                      letterSpacing: '0.5px'
                    }}>
                    {pharmacy.name.split(' ')[0][0]}
                    </Typography>
                    {pharmacy.name.split(' ').length > 1 && (
                    <Typography variant="h6" style={{ 
                      color: "white",
                      fontSize: '16px',
                      fontWeight: 500,
                      letterSpacing: '0.5px'
                    }}>
                    {pharmacy.name.split(' ')[1][0]}
                    </Typography>
                    )}
                    </div>
                  <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flex: 1,
                    position: 'relative',
                  }}
                  >
                  {isSubmitting && selectedPharmacyId === pharmacy.id && (
                    <div style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 1,
                      backgroundColor: 'rgba(255, 255, 255, 0.8)',
                      borderRadius: '50%',
                      padding: '8px',
                      backdropFilter: 'blur(2px)',
                    }}>
                    <CircularProgress 
                      style={{ 
                        color: primaryColor,
                        width: 24,
                        height: 24,
                      }}
                      thickness={4}
                    />
                    </div>
                  )}
                  <Typography variant="h6" style={{ 
                    flex: 1,
                    fontSize: '16px',
                    fontWeight: 500,
                    color: '#2c3e50'
                  }}>{pharmacy.name}</Typography>
                  {pharmacy.approval.status !== "approved" && (
                    <Typography
                    variant="caption"
                    style={{
                      fontSize: '12px',
                      fontWeight: 500,
                      color: 'white',
                      backgroundColor: 'rgba(255, 68, 68, 0.9)',
                      padding: '6px 12px',
                      borderRadius: '20px',
                      marginLeft: '16px',
                      boxShadow: '0 2px 4px rgba(255, 68, 68, 0.2)',
                      letterSpacing: '0.3px'
                    }}
                    >
                    Under Review
                    </Typography>
                  )}
                  </div>
                </div>
            ))}
            {filteredPharmacies.length === 0 && (
              <Typography
                style={{
                  color: Colors.darkGrey,
                  fontSize: FontSize.small,
                  paddingTop: Spacing.small,
                }}
              >
                No matching {title} found.
              </Typography>
            )}
          </div>
          )}
        </FormControl>
        <div style={{ padding: Spacing.medium }}>
          <Typography variant={"caption"}>
            {newTitle+ ' '+ Claims.switchPharmacy}
          </Typography>
        </div> 
      </RBCardView>
    );
  };

  return <>
    <RBAlert
      show={isAlertShowing}
      alertTitle={alertInfo.title}
      alertMessage={alertInfo.message}
      buttons={alertInfo.buttons}
    />
    {renderPharmacies()}
  </>;
};
